'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import Box, { BoxProps } from '../../box'

/* -----------------------------------------------------------------------------
 * FieldPrefix
 * -------------------------------------------------------------------------- */

export type FieldPrefixProps = BoxProps & {
  children: React.ReactNode
  compact?: boolean
}

const FieldPrefix = ({ children, compact, ...props }: FieldPrefixProps) => {
  return (
    <Box
      position='absolute'
      zIndex={1}
      top={0}
      bottom={0}
      left={compact ? 6 : 8}
      width={20}
      alignItems='center'
      justifyContent='center'
      pointerEvents='none'
      {...props}
    >
      {children}
    </Box>
  )
}

export default FieldPrefix
